import React from "react";
import CustomPaginationActions from "../Pagination/CustomPaginationActions";
import { useTranslation } from "react-i18next";
import { TablePagination } from "../primitives";

const CustomPagination = (props) => {
  const {
    page,
    rowsPerPage,
    count,
    handleChangePage,
    handleChangeRowsPerPage,
  } = props;

  const value =
    (page + 1) * rowsPerPage < count ? (page + 1) * rowsPerPage : count;
  const rowsPerPageOptions = [10, 25, 50, 75, 100];

  const { t } = useTranslation();

  return (
    <TablePagination
      component="div"
      rowsPerPage={rowsPerPage}
      count={count}
      page={page}
      ActionsComponent={CustomPaginationActions}
      labelDisplayedRows={({ page }) => {
        return `${page * rowsPerPage + 1} - ${value} ${t("erps.pagination.to", "to")} ${count}`;
      }}
      rowsPerPageOptions={rowsPerPageOptions}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      aria-label="Pagination for search results"
    />
  );
};

export default CustomPagination;
